module.exports = __webpack_public_path__ + "static/media/bg17.2adf60d9.jpg";